<template>
    <Admin
        :title="__('Products', null, $page.props.profile_locale)"
    >
        <div class="overflow-auto w-full shadow-md rounded-md">
        <table class="w-full whitespace-nowrap">
            <thead class="relative">
                <tr
                    class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700"
                >
                    <th class="px-4 py-3">{{__('Product', null, $page.props.profile_locale)}}</th>
                    <th class="px-4 py-3">{{__('Price', null, $page.props.profile_locale)}}</th>
                    <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                </tr>
                <InertiaLink
                    :href="route('add.product')"
                    class="absolute top-1/2 right-2 transform -translate-y-1/2 rounded-full overflow-hidden hover:text-white text-gray-200"
                >
                    <SvgIcon
                        name="plus-circle"
                        class="mx-auto "
                    />

                </InertiaLink>
            </thead>
            <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                <tr v-for="product in products.data" :key="product"
                    class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                    <td class="px-4 py-3">
                        <div class="flex items-center text-sm">
                            <div class="relative hidden w-10 h-10 mr-3 rounded-full md:block">
                                <img
                                    v-if="product.sortedImages.length"
                                    class="object-cover w-full h-full border-2 border-gray-600 rounded-full"
                                    :src="getProductImage(product.sortedImages)"
                                    alt="" loading="lazy">
                                <div class="absolute inset-0 rounded-full shadow-inner" aria-hidden="true"></div>
                            </div>
                            <div>
                                <InertiaLink
                                    class="font-bold hover:underline"
                                    :href="route('product', product.slug)"
                                    v-html="product.name.trimText(60)"
                                />
                                <p class="text-xs text-gray-600 dark:text-gray-400" v-html="product.short_description.trimText(90)"></p>
                            </div>
                        </div>
                    </td>
                    <td class="px-4 py-3 text-sm">
                        <span
                            class="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100 whitespace-nowrap"
                        >
                            {{ product.pieces_type != 'packages' ? getPrice(product.price) : getPackagePrice(product.pieces_item) }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm flex">
                        <IconLink
                            color="gray"
                            icon="pencil"
                            class="p-1 mr-1"
                            :href="route('dashboard.admin.product.edit', product.id)"
                        ></IconLink>
                        <IconLink
                            color="gray"
                            icon="chat"
                            class="p-1 mr-1"
                            :href="route('dashboard.admin.product.reviews', product.id)"
                        >
                            <template #addon>
                                <span class="font-bold">{{ product.reviews.length }}</span>
                            </template>
                        </IconLink>
                        <IconLink
                            color="gray"
                            icon="question"
                            class="p-1 mr-1"
                            :href="route('dashboard.admin.product.questions', product.id)"
                        >
                            <template #addon>
                                <span class="font-bold">{{ product.questions.length }}</span>
                            </template>
                        </IconLink>
                        <IconLink
                            color="gray"
                            icon="download"
                            class="p-1 mr-1"
                            :href="route('dashboard.admin.product.downloads', product.id)"
                        >
                            <template #addon>
                                <span class="font-bold">{{ product.files.length }}</span>
                            </template>
                        </IconLink>

                        <IconLink
                            color="red"
                            icon="trash"
                            class="p-1 ml-auto"
                            method="post"
                            :href="route('product.remove', product.id)"
                        ></IconLink>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <PaginateLink
            class="mt-5"
            :links="products.links"
        />
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import BreezeInput from 'COMP/Input';
    import BreezeLabel from 'COMP/Label';
    import BreezeButton from 'UI/Button';
    import Button from 'UI/Button';
    import BreezeNavLink from 'COMP/NavLink';
    import SvgIcon from 'UI/SvgIcon';
    import PaginateLink from 'UI/PaginateLink';

    import IconLink from 'UI/IconLink';

    import {
        getPrice,
        getPackagePrice,
        getProductImage,
    } from 'helper';

    export default {
        props: {
            products: [Object, Array]
        },
        components: {
            Admin,
            BreezeInput,
            BreezeLabel,
            BreezeButton,
            Button,
            BreezeNavLink,
            SvgIcon,
            IconLink,
            PaginateLink
        },
        methods: {
            getPrice,
            getProductImage,
            getPackagePrice
        }

    }
</script>
